import LoadingSpinner from "app/components/LoadingSpinner/LoadingSpinner";
import React from "react";
import { FormattedMessage } from "react-intl";

type Props = {
  isSubmitting: boolean;
  fileSelected: boolean;
};

const SubmitForm: React.FC<Props> = ({ isSubmitting, fileSelected }) => {
  if (isSubmitting) {
    return <LoadingSpinner />;
  } else {
    return (
      <button
        className="documents__form__file-upload__submit"
        type="submit"
        disabled={!fileSelected}
      >
        <FormattedMessage tagName="span" id="button-submit" />
      </button>
    );
  }
};

export default SubmitForm;
